module.exports = __webpack_public_path__ + "static/big-save-logo-ce38c2bd154fe74d719540ef58a47285.svg";